import React, { useId } from "react";
import { Stack, TextField, Typography } from "@mui/material";

export default function ActionFormField({
  label,
  helperText,
  error,
  action,
  inputProps,
  select,
  children,
  ...props
}) {
  const id = useId();
  const labelId = `${id}-label`;

  return (
    <Stack spacing={1} sx={{ flex: 1, minWidth: 0 }}>
      <Typography id={labelId} component='label' htmlFor={id} variant='body2' fontWeight={600}>
        {label}
      </Typography>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems='flex-start'>
        <TextField
          {...props}
          id={id}
          size='small'
          fullWidth
          select={select}
          inputProps={{ ...inputProps, "aria-labelledby": labelId }}
          SelectProps={select ? { displayEmpty: true, SelectDisplayProps: { "aria-labelledby": labelId } } : undefined}
          error={Boolean(error)}
          helperText={error || helperText}
          FormHelperTextProps={{ sx: { mx: 0, mt: 1, lineHeight: 1.5 } }}
        >
          {children}
        </TextField>
        {action}
      </Stack>
    </Stack>
  );
}
